import {Injectable} from '@angular/core';
import {Action, State, StateContext, Store} from '@ngxs/store';
import { CommonService } from 'src/app/services/common.service';
import {FilterObject} from '../../../shared/models/FilterBarObject';
import { ReportConfigurationMetaData } from '../../models/reports/reports-query-result';
import {ReportSectionMenuItem} from '../../models/reports/reports.interface';
import {ReportsService} from '../../services/reports.service';
import {GetReport, GetReportsConfiguration, SelectReportMenuItem, SetSelectedReportFilter} from './reports.actions';
import {ReportsStateModel} from './reports.model';

const reportsMenu: ReportSectionMenuItem[] = [
  {
    type: 'immediate',
    items: [{
      id: 1,
      title: 'Who is been in today?',
      commandType: 'whoIsBeenInTodayReport',
      dropDownFilterParams: [
        {
          name: 'department',
          placeHolder: 'All departments',
          collection: [{ key: null, name: 'All departments' }],
          selectedItem: null
        },
        {
          name: 'location',
          placeHolder: 'All doors',
          collection: [{ key: null, name: 'All doors' }],
          selectedItem: null
        },
        {
          name: 'timeRangePicker',
          placeHolder: 'All time frames',
          collection: [],
          selectedItem: null
        }
      ],
      columns: [
        {title: 'type', field: 'type'},
        {title: 'name', field: 'name'},
        {title: 'department', field: 'department', frProp: '1fr'},
        {title: 'location', field: 'location'},
        {title: 'time', field: 'time'}]
    },
      {
        title: 'Last know position', commandType: 'lastKnowPosition', dropDownFilterParams: [
          {
            name: 'position',
            placeHolder: 'Positions',
            collection: [{key: 1, name: 'Absolute'}, {key: 2, name: 'Fixed'}],
            selectedItem: null
          }]
      },
      {title: 'Roll call readers', commandType: 'rollCallReaders'},
      {title: 'Access area occupancy', commandType: 'accessAreaOccupancy'}]
  },
  {
    type: 'controllers',
    items: [{
      id: 2,
      title: 'Attendance',
      commandType: 'attendanceReport',
      columns: [
        // {title: 'name', field: 'name'},
        {title: 'date', field: 'date'},
        {title: 'day', field: 'day'},
        {title: 'in', field: 'entry'},
        {title: 'out', field: 'exit'},
        {title: 'duration', field: 'duration in hours'},
        // {title: 'description', field: 'description'},
        {title: 'comments', field: 'comments'}
        // {title: 'department', field: 'department'}
      ],
      dropDownFilterParams: [
        {
          name: 'savedReport',
          placeHolder: 'Custom reports',
          collection: [{ key: -1, name: 'Custom reports' }],
          selectedItem: null
        },
        {
          name: 'departmentName',
          placeHolder: 'All departments',
          collection: [{ key: null, name: 'All departments' }],
          selectedItem: null
        },
        {
          name: 'employeeId',
          placeHolder: 'All users',
          collection: [{ key: null, name: 'All users' }],
          selectedItem: null
        },
        {
          name: 'month',
          placeHolder: 'All months',
          collection: [
            {key:'Jan', name: 'January'},
            {key:'Feb', name: 'February'},
            {key:'Mar', name: 'March'},
            {key:'Apr', name: 'April'},
            {key:'May', name: 'May'},
            {key:'Jun', name: 'June'},
            {key:'Jul', name: 'July'},
            {key:'Aug', name: 'August'},
            {key:'Sep', name: 'September'},
            {key:'Oct', name: 'October'},
            {key:'Nov', name: 'November'},
            {key:'Dec', name: 'December'}
          ],
          selectedItem: null
        }
      ]
    },
      {title: 'Controllers', commandType: 'controllers'},
      {title: 'Access', commandType: 'access'},
      {title: 'User access rights', commandType: 'userAccessRights'},
      {title: 'Doors access rights', commandType: 'doorsAccessRights'},
      {title: 'Controller links', commandType: 'controllerLinks'}]
  }, {
    type: 'system',
    items: [
      {title: 'System', commandType: 'system'},
      {title: 'Operators', commandType: 'operators'},
      {title: 'Alerts & antipassback', commandType: 'alertsAntipassback'},
      {title: 'Non-responding users', commandType: 'non-respondingUsers'},
      {title: 'Lockdown', commandType: 'lockdown'}]
  }
];

@State<ReportsStateModel>({
  name: 'reports',
  defaults: {
    configuration: null,
    isLoadingData: false,
    reportData: {
      filter: <FilterObject<any>> {search: '', filter: {}},
      report: [],
      totalCount: 0
    },
    selectedReportMenuItem: null,
    reportsMenu
  }
})
@Injectable()
export class ReportsState {
  constructor(private readonly reportService: ReportsService, private store: Store, private commonService: CommonService) {
  }

  @Action(SelectReportMenuItem)
  async selectReportMenuItem(ctx: StateContext<ReportsStateModel>, action: SelectReportMenuItem) {
    ctx.patchState({
      selectedReportMenuItem: action.reportItem, reportData: {
        filter: <FilterObject<any>> {search: '', filter: {}},
        report: [],
        totalCount: 0
      }
    });
    // ctx.patchState({reportData: {id: action.reportId}})
  }

  @Action(GetReport)
  async getReport(ctx: StateContext<ReportsStateModel>, action: GetReport) {
    ctx.patchState({isLoadingData: true});
    const {reportData} = ctx.getState();
    let report = await this.reportService.getReport(action.reportType, action.args);
    if (report?.results) {
      if (action.reportType === 'attendanceReport') {
        report.results = report.results.sort(this.commonService.compareByEmployeeNameAscFn);

      } else {
        report.results = report.results.sort(this.commonService.compareByNameAscFn);
        report.results.map(item => {
          if (item.name) {
            let arrayOfWords = item.name.split(',');
            if (arrayOfWords && arrayOfWords[1] && (arrayOfWords[1].length === 1 || arrayOfWords[1].length === 0)) {
              item.name = arrayOfWords[0];
            }
          }
        });
      }
      ctx.patchState({
        reportData: {
          report: report?.results,
          filter: reportData.filter,
          totalCount: report?.totalCount
        },
        isLoadingData: false
      });
    }
  }

  @Action(SetSelectedReportFilter)
  async setSelectedReportFilter(ctx: StateContext<ReportsStateModel>, action: SetSelectedReportFilter) {
    const {reportData} = ctx.getState();
    if (reportData) {
      for (const [key, value] of Object.entries(action.filterObj.filter)) {
        if(value !== null){
          reportData.filter.filter[key] = value;
        }else {
          delete reportData.filter.filter[key];
        }
      }
      reportData.filter.search = action.filterObj.search;
      ctx.patchState({reportData: {...reportData}});
    }
  }

  @Action(GetReportsConfiguration)
  async getReportsConfiguration(ctx: StateContext<ReportsStateModel>) {
    ctx.patchState({isLoadingData: true});
    const configuration: ReportConfigurationMetaData = await this.reportService.getConfiguration();
    configuration.attendanceSavedReports.unshift({ id: -1, description: 'Custom reports' });
    ctx.patchState({isLoadingData: false});
    if (configuration) {
      ctx.patchState({configuration});
    }
  }
}
